
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hts-code/chapter/[index]",
      function () {
        return require("private-next-pages/hts-code/chapter/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hts-code/chapter/[index]"])
      });
    }
  